import React, { createContext, useEffect, useState } from 'react'

import { useParams } from 'react-router-dom'

import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import PreviewIcon from '@mui/icons-material/Visibility'

import StatisticsEditTable from '../components/tables/StatisticsEditTable'

import { StatisticsEditPageMain, StatisticsEditPageTileTitle } from '../styles/pages/StatisticsEditPageStyle'
import LinkButton from '../components/LinkButton'
import statisticsApi from '../api/statistics'
import useHandleError from '../api/useHandleError'
import { setViewportWidth } from '../useViewPort'

export const StatisticEditPageContext = createContext({})

const StatisticsEditPage = () => {
  const { id } = useParams()
  const [tileTitle, setTileTitle] = useState('')
  const [rowsData, setRowsData] = useState([])
  const handleError = useHandleError()

  const getData = () => {
    const apiRequest = id ? statisticsApi.getTile(id) : statisticsApi.list()
    return apiRequest.then((data) => data.data).catch(handleError)
  }

  const handleUpdate = () => {
    const updatedTile = {
      name: tileTitle,
      rows: rowsData,
    }
    statisticsApi.updateTile(id, updatedTile).catch(handleError)
    setTimeout(() => setViewportWidth())
  }

  const handleChange = (e) => {
    setTileTitle(e.target.value)
  }

  useEffect(() => {
    async function fetchData() {
      const getTileData = await getData()
      if (getTileData) {
        setRowsData(getTileData.rows)
        setTileTitle(id ? getTileData.name : '')
      }
    }

    fetchData()
  }, [])

  return (
    <StatisticEditPageContext.Provider value={{ getData: getData }}>
      <StatisticsEditPageMain>
        <LinkButton
          handleClick={handleUpdate}
          url={'/statistics/'}
          icon={<ArrowBackIcon />}
          aria-label="goBackButton"
        />
        <LinkButton
          handleClick={handleUpdate}
          url={`/statistics/view/${id}`}
          icon={<PreviewIcon />}
          text="Preview"
          variant="outlined"
        />
        <StatisticsEditPageTileTitle
          required
          label="Statistic view name"
          variant="outlined"
          value={tileTitle || ''}
          onChange={handleChange}
          onBlur={handleUpdate}
          aria-label="tileNameInput"
        />
        <StatisticsEditTable rowsData={rowsData} />
      </StatisticsEditPageMain>
    </StatisticEditPageContext.Provider>
  )
}

export default StatisticsEditPage
